import * as types from "../constants";

// Restore the session persisted by authenticate() so a page reload
// (e.g. Chrome discarding an idle tab) doesn't start as signed out.
function loadStoredUser() {
  try {
    const stored = localStorage.getItem("user");
    return stored !== null ? JSON.parse(stored) : undefined;
  } catch {
    return undefined;
  }
}

const storedUser = loadStoredUser();

const initialState = {
  isAuthenticated:
    storedUser !== undefined &&
    localStorage.getItem("authenticated") === "true",
  user: storedUser,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.IS_AUTHENTICATED_TOGGLE:
      return {
        ...state,
        isAuthenticated: !state.isAuthenticated,
      };
    case types.IS_AUTHENTICATED_TRUE:
      return Object.assign({}, state, {
        isAuthenticated: true,
        user: action.user,
      });
    case types.IS_AUTHENTICATED_FALSE:
      return Object.assign({}, state, {
        isAuthenticated: false,
        user: null,
      });

    default:
      return state;
  }
}
